var map = {
	"./icons/All companies.svg": 845,
	"./icons/Factoring.svg": 846,
	"./icons/Profile.svg": 847,
	"./icons/Settings.svg": 848,
	"./icons/authorize.svg": 849,
	"./icons/branding.svg": 850,
	"./icons/broker.svg": 851,
	"./icons/carriers.svg": 852,
	"./icons/clock.svg": 853,
	"./icons/company_profile.svg": 854,
	"./icons/connect.svg": 454,
	"./icons/contact.svg": 855,
	"./icons/contacts.svg": 856,
	"./icons/credentials.svg": 857,
	"./icons/customers.svg": 858,
	"./icons/dashboard.svg": 859,
	"./icons/delivered.svg": 860,
	"./icons/download (1) 1 (2).svg": 861,
	"./icons/driver.svg": 862,
	"./icons/drivers.svg": 863,
	"./icons/email_accounts.svg": 864,
	"./icons/email_templates.svg": 865,
	"./icons/engine.svg": 866,
	"./icons/geofence.svg": 867,
	"./icons/hash.svg": 868,
	"./icons/help.svg": 869,
	"./icons/hos.svg": 870,
	"./icons/icon_banks.svg": 871,
	"./icons/icon_blog.svg": 872,
	"./icons/icon_cancel.svg": 873,
	"./icons/icon_charts.svg": 874,
	"./icons/icon_checks.svg": 875,
	"./icons/icon_column.svg": 876,
	"./icons/icon_components.svg": 877,
	"./icons/icon_controllers.svg": 878,
	"./icons/icon_delete.svg": 879,
	"./icons/icon_dollars.svg": 880,
	"./icons/icon_edit.svg": 881,
	"./icons/icon_filter.svg": 882,
	"./icons/icon_form.svg": 883,
	"./icons/icon_grid.svg": 884,
	"./icons/icon_hold.svg": 885,
	"./icons/icon_link.svg": 886,
	"./icons/icon_logo.svg": 887,
	"./icons/icon_logoFullname.svg": 888,
	"./icons/icon_logoFullname1.svg": 889,
	"./icons/icon_notification.svg": 890,
	"./icons/icon_payments_trans.svg": 891,
	"./icons/icon_profile.svg": 892,
	"./icons/icon_redirect.svg": 893,
	"./icons/icon_redux.svg": 894,
	"./icons/icon_reject.svg": 895,
	"./icons/icon_setting.svg": 896,
	"./icons/icon_table.svg": 897,
	"./icons/icon_view.svg": 898,
	"./icons/link.svg": 899,
	"./icons/loads.svg": 900,
	"./icons/location.svg": 901,
	"./icons/logo.svg": 902,
	"./icons/mail.svg": 903,
	"./icons/opt_in-out.svg": 904,
	"./icons/safety.svg": 905,
	"./icons/tasks.svg": 906,
	"./icons/trucks.svg": 907,
	"./icons/users.svg": 908,
	"./icons/vehicle.svg": 909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 844;